import { render, staticRenderFns } from "./qMaster.vue?vue&type=template&id=4662bb46&"
import script from "./qMaster.vue?vue&type=script&lang=ts&"
export * from "./qMaster.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports